import React from 'react';
import { Link } from 'react-router-dom';
import { Seo, PackagesGroupTripsBar, ContentGuidesStrip } from '../shared';
import BookingPageHero from '../booking/BookingPageHero';
import PrivateTourRequestForm from '../booking/PrivateTourRequestForm';
import PrivateTourInfoAside from '../booking/PrivateTourInfoAside';
import '../../styles/pkgs-gt-bar.scss';
import '../../styles/booking-experience.scss';

function PackagesPage() {
	return (
		<>
			<Seo
				title="Private Tours"
				path="/packages"
				noindex
				description="Request a private Nepal tour through VisitAllNepal — your dates, your group. No public listings; we assign the best verified operator."
			/>
			<PackagesGroupTripsBar />
			<BookingPageHero
				title="Private Tours"
				subtitle="Every private tour is unique. Tell us your journey, dates, and needs — VisitAllNepal handles logistics and operator assignment."
			/>

			<section className="booking-page" aria-label="Private tour request">
				<div className="booking-page__inner container">
					<ContentGuidesStrip compact />
					<div className="booking-split">
						<div className="booking-split__main">
							<div className="booking-form-panel">
								<header className="booking-form-panel__head">
									<h2 className="booking-form-panel__title">Request a private tour</h2>
									<p className="booking-form-panel__hint">Your dates, your group — one request, we handle the rest</p>
								</header>
								<PrivateTourRequestForm embedded />
							</div>
						</div>
						<aside className="booking-split__aside">
							<PrivateTourInfoAside />
						</aside>
					</div>
					<p className="booking-page__alt">
						Prefer fixed dates with other travellers?{' '}
						<Link to="/group-trips">Join a group departure</Link>.
					</p>
				</div>
			</section>
		</>
	);
}

export default PackagesPage;
